'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inputEnhancer = require('./inputEnhancer');

var _inputEnhancer2 = _interopRequireDefault(_inputEnhancer);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Input = (0, _inputEnhancer2.default)(_Input2.default);
Input.displayName = 'Input';

exports.default = Input;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/Input/index.js
// module id = 1671
// module chunks = 0